import { LoadingActions } from './action-creators';
import { Reducer } from 'redux';
import { actionTypes } from './action-types';

export interface LoadingStore {
  loading: boolean;
}

const initialState: LoadingStore = {
  loading: false,
};

export const loadingReducer: Reducer<LoadingStore, LoadingActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};
